
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AccountService } from '../../services/account.service';
import { SCAMP_API, SCAMP_API_RPT } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { PTLight } from './models/pt.light.model';
import { PtParaAvalicacao } from './models/pt.para.avalicao.model';
import { SpvAcompanhar } from '../../models/spv-acompanhar.model';
import { RetornoApi } from '../../models/retornoApi.model';


@Injectable({providedIn : 'root'})
export class PTService {

    constructor(
        private http: HttpClient,
        private account: AccountService
    ) { }

    getPTComColecoesFilhas(id: number): Observable<any> {
        return this.http.get<any>(`${SCAMP_API.accountApiV1}/pt-com-colecoes/${id}`, {headers : this.account.composeHeaders()});
    }
    getPTsStatusAberto(): Observable<PTLight[]> {
        return this.http.get<PTLight[]>(`${SCAMP_API.accountApiV1}/pts-status-aberto`, {headers : this.account.composeHeaders()});
    }

    save(data)  {
        return this.http.post(`${SCAMP_API.accountApiV1}/pt`, data, {headers : this.account.composeHeaders()});
    }

   

    getPTParaAvaliacao(id: number): Observable<PtParaAvalicacao> {
        return this.http.get<PtParaAvalicacao>(
            `${SCAMP_API.accountApiV1}/pt-para-avaliacao/${id}`,
            {headers : this.account.composeHeaders()}
            );
    }

   /*  recusarPT(data) {
        return this.http.put(`${SCAMP_API.accountApiV1}/recusar-pt`, data, {headers : this.account.composeHeaders()});
    } */

   /*  aprovarPT(data) {
        return this.http.put(`${SCAMP_API.accountApiV1}/aprovar-pt`, data, {headers : this.account.composeHeaders()});
    } */

    pesquisarptsPorPeriodo(data): Observable<SpvAcompanhar[]> {
        return this.http.post<SpvAcompanhar[]>(
            `${SCAMP_API.accountApiV1}/pt-pesquisar-por-periodo`, data,
            {headers : this.account.composeHeaders()}
            );
    }

    // Servidor de Relatórios
    getAcompanharPTs(data): Observable<RetornoApi> {
        return this.http.post<RetornoApi>(`${SCAMP_API_RPT.accountApiV1}/pt-pesquisar-por-periodo`, data);
    }


}
